/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResponsiblePersonDetails/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaProfileValueWithLabelText from 'DesignSystem/TysiaProfileElements/TysiaProfileValueWithLabelText/index'



/** @type {import('Simple/types.js').View} */
export default function ResponsiblePersonDetails({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/ResponsiblePersonDetails"
  
}) {
let leadMetadataResponsibleFirstnameValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.firstName',
})
let leadMetadataResponsibleLastnameValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.lastName',
})
let leadMetadataResponsibleRelationshiptypeValueData = fromData.useDataFormat({ viewPath,
context: 'lead',
path: 'metadata.responsible.relationshipType',
format: fromFormat.toTitleCase,
})
let leadMetadataResponsibleEmailValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.email',
})
let leadMetadataResponsiblePhonedetailsNumberValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.phoneDetails.number',
})
let constantData = ' ('
let leadMetadataResponsiblePhonedetailsTypeValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.phoneDetails.type',
})
let constantData1 = ')'
let aggregateData = fromHelpers.joinPhone(leadMetadataResponsiblePhonedetailsNumberValueData, constantData, leadMetadataResponsiblePhonedetailsTypeValueData, constantData1)
  return (<React.Fragment
>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="First Name"
 data="lead.metadata.responsible.firstName"
 value={leadMetadataResponsibleFirstnameValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Last Name"
 data="lead.metadata.responsible.lastName"
 value={leadMetadataResponsibleLastnameValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Relationship"
 data="lead.metadata.responsible.relationshipType"
 format="/Data/format.js toTitleCase"
 value={leadMetadataResponsibleRelationshiptypeValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Email"
 data="lead.metadata.responsible.email"
 value={leadMetadataResponsibleEmailValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Phone"
 data="lead.metadata.responsible.phoneDetails.number"
 data="' ('"
 data="lead.metadata.responsible.phoneDetails.type"
 data="')'"
 aggregate="helpers.js joinPhone"
 value={aggregateData}
/>
{children}
</React.Fragment>)
}